import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";
import { INTEGRATION_SCOPES } from "../constants";

import type { IntegrationScope } from "../constants";
import type { ConnectAPIResponse } from "../types/integrations";

// The scope is part of the key because the same source list differs per tier — a
// deployment caller gets private sources only.
export const INTEGRATIONS_QUERY_KEY = (
  integrationScope: IntegrationScope = INTEGRATION_SCOPES.USER,
) => ["integrations", integrationScope] as const;

// TODO: Remove this once all integrations are done
const HIDE_INTEGRATIONS = ["needldrive", "whatsapp", "evernote"];

export const useFetchAllIntegrations = (
  integrationScope: IntegrationScope = INTEGRATION_SCOPES.USER,
) => {
  return useQuery({
    queryKey: INTEGRATIONS_QUERY_KEY(integrationScope),
    queryFn: async () => {
      return await axiosInstance.get<ConnectAPIResponse>("/connect", {
        params: { integration_scope: integrationScope },
      });
    },
    select: (response) => {
      return response.data.results.filter(
        (integration) =>
          !integration.disabled &&
          integration.private &&
          !HIDE_INTEGRATIONS.includes(integration.label),
      );
    },
  });
};
